/**
 * ValueType
 * An enumeration.
 */
export enum ValueType {
  STRING = 'STRING',
  INT = 'INT',
  FLOAT = 'FLOAT',
  BOOL = 'BOOL',
  DATETIME = 'DATETIME',
  STRING_LIST = 'STRING_LIST',
  JSONB = 'JSONB',
  TEXT = 'TEXT',
  FILE = 'FILE',
}